import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, Typography, Input } from 'antd';
import {
  MIN_AMOUNT,
  MAX_AMOUNT,
  BASE_RATE_KEY_TYPE,
  BASE_RATE_KEY_VALUE,
  RUPEE_SIGN,
  PERCENTAGE,
  PERCENTAGE_SIGN,
  INFINITY_SIGN
} from './const';

function BaseRateSlabList({ baseRateSlab }) {
  const [baseRateSlabForm] = Form.useForm();
  const baseRateSlabKey = 'baseRateSlab';

  const checkedModeSlab = baseRateSlab?.baseRateSlab;

  useEffect(() => {
    if (baseRateSlab) {
      baseRateSlabForm.setFieldValue([baseRateSlabKey], baseRateSlab?.baseRateSlab);
    }
  });
  return (
    <Form form={baseRateSlabForm} layout="vertical" disabled>
      <Form.List name={[baseRateSlabKey]}>
        {(fields) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Row gutter={[32, 32]}>
                <Col span={6}>
                  <Form.Item
                    label={
                      <Typography.Text
                        style={{ color: '#8F93A8', fontWeight: 400, fontSize: '14px' }}
                      >
                        Min Amount{' '}
                      </Typography.Text>
                    }
                    name={[name, MIN_AMOUNT]}
                    key={[name, MIN_AMOUNT]}
                    {...restField}
                  >
                    <Input
                      prefix={RUPEE_SIGN}
                      placeholder="Enter Min Amount"
                      style={{ width: '100%' }}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label={
                      <Typography.Text
                        style={{ color: '#8F93A8', fontWeight: 400, fontSize: '14px' }}
                      >
                        Max Amount{' '}
                      </Typography.Text>
                    }
                    name={
                      checkedModeSlab.at(name).max_amount === 'Infinity'
                        ? [name, '']
                        : [name, MAX_AMOUNT]
                    }
                    key={[name, MAX_AMOUNT]}
                    {...restField}
                  >
                    <Input
                      prefix={
                        checkedModeSlab.at(name).max_amount === 'Infinity'
                          ? INFINITY_SIGN
                          : RUPEE_SIGN
                      }
                      placeholder={
                        checkedModeSlab.at(name).max_amount === 'Infinity' ? '' : 'Enter Max Amount'
                      }
                      style={{ width: '100%' }}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label={
                      <Typography.Text
                        style={{ color: '#8F93A8', fontWeight: 400, fontSize: '14px' }}
                      >
                        Type{' '}
                      </Typography.Text>
                    }
                    name={[name, BASE_RATE_KEY_TYPE]}
                    key={[name, BASE_RATE_KEY_TYPE]}
                    {...restField}
                  >
                    <Input
                      placeholder="Please select a type"
                      disabled
                      key={[name, BASE_RATE_KEY_TYPE]}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label={
                      <Typography.Text
                        style={{ color: '#8F93A8', fontWeight: 400, fontSize: '14px' }}
                      >
                        Charge{' '}
                      </Typography.Text>
                    }
                    name={[name, BASE_RATE_KEY_VALUE]}
                    key={[name, BASE_RATE_KEY_VALUE]}
                    {...restField}
                  >
                    <Input
                      prefix={
                        checkedModeSlab.at(name).base_rate_type === PERCENTAGE
                          ? PERCENTAGE_SIGN
                          : RUPEE_SIGN
                      }
                      placeholder="Enter Base Rate Value"
                      style={{ width: '100%' }}
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>
            ))}
          </>
        )}
      </Form.List>
    </Form>
  );
}

BaseRateSlabList.propTypes = {
  baseRateSlab: PropTypes.instanceOf(Object).isRequired
};

export default BaseRateSlabList;
